import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { CreateVesselFormRequest } from "../models/vessel.models";

@autoinject()
export class VesselService {

    private _rightShipPlatformApi: string;
    
    constructor(private requestClientService: RequestClientService, private configService: ConfigService) {
        this._rightShipPlatformApi = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/Vessel`;
    }

    //Create vessel form
    public async createVesselForm(createVesselFormRequest: CreateVesselFormRequest): Promise<string> {
        try {
            return await this.requestClientService.post<string>(`${this._rightShipPlatformApi}/CreateVesselForm`, {}, createVesselFormRequest);
        }
        catch (e) {
            console.error(e);
        }
    }
}